import FormattedMessage from 'I18n/components/FormattedMessage';
import ListingLibMoveAssetsModal from 'framework-listing-lib/dialog/ListingLibMoveAssetsModal';
import { getPropertyValue } from 'framework-listing-lib/utils/crmObject';
import FormTypes from 'forms-utils-lib/constants/formDefinition/FormTypes';
import { FORMS_WRITE } from 'FormsUI/constants/Scopes';
import { PROPERTIES } from 'FormsUI/components/dashboard/frameworkTable/constants';
import { jsx as _jsx } from "react/jsx-runtime";
const moveToFolderAction = {
  id: 'move-to-folder',
  name: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "moveToFolder"
  }),
  actionGroup: ({
    crmObject,
    layoutUse
  }) => {
    if (!layoutUse || layoutUse === 'detail-actions') {
      return 3;
    }
    const formType = getPropertyValue(crmObject, PROPERTIES.FORM_TYPE);
    if (formType === FormTypes.CAPTURED) {
      return 4;
    }
    return 3;
  },
  orderInActionGroup: ({
    crmObject,
    layoutUse
  }) => {
    if (!layoutUse || layoutUse === 'detail-actions') {
      return 0;
    }
    const formType = getPropertyValue(crmObject, PROPERTIES.FORM_TYPE);
    if (formType === FormTypes.CAPTURED || formType === FormTypes.FLOW) {
      return 1;
    }
    return 0;
  },
  DisabledTooltipContent: () => /*#__PURE__*/_jsx(FormattedMessage, {
    message: "permissions.disallowed"
  }),
  enablePermissions: {
    scopes: [FORMS_WRITE]
  },
  displayPermissions: {
    custom: ({
      nonCrmObject
    }) => {
      return Boolean(nonCrmObject && nonCrmObject.type === 'DASHBOARD');
    }
  },
  ModalOrPanel: ({
    crmObject,
    onClose
  }) => {
    return /*#__PURE__*/_jsx(ListingLibMoveAssetsModal, {
      selectedObjectOrObjects: crmObject,
      onClose: onClose
    });
  }
};
export default moveToFolderAction;